import React, { useEffect, useRef } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  compose,
  setPropTypes,
  lifecycle,
  withHandlers,
  withState
} from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import {
  Button,
  Card,
  CardContent,
  CardMedia,
  Checkbox,
  FormControlLabel,
  Link,
  List,
  ListItem,
  MenuItem,
  Modal,
  Paper,
  Radio,
  RadioGroup,
  TextField,
  Typography
} from '@material-ui/core';
import {
  AddCircleOutline,
  KeyboardArrowDown,
  KeyboardArrowUp,
  RemoveCircleOutline
} from '@material-ui/icons';
import HelpIcon from '@material-ui/icons/HelpOutlined';
import CloseIcon from '@material-ui/icons/Close';
import moment from 'moment';
import classNames from 'classnames';
import { isNaN } from 'lodash';
import {
  ADD_GOCHI_MENU_SUCCESS,
  addGochiMenu,
  addGochiMenuImage
} from '../../actions/GochiMenus';
// import { getShops } from '../../actions/Shop';
import { languages, languageType } from '../../constants/Language';
import { resizeImage, sendLogin, uploadFile } from '../../auth/Auth';
import RequiredButton from '../../components/atoms/RequiredButton';
import ValidationText from '../../components/atoms/ValidationText';
import usageTypes from '../../constants/UsageType';
import FileUpload from '../../components/molecules/FileUpload';
import AnyButton from '../../components/atoms/AnyButton';
import CancelButton from '../../components/atoms/CancelButton';
import ConfirmButton from '../../components/atoms/ConfirmButton';
import MenuImageSampleShopDialog from './MenuImageSampleShopDialog';
import GochiMenuAddConfirmShopV2 from './GochiMenuAddConfirmShopV2';

const styles = theme => ({
  root: {
    // position: 'absolute',
    width: '100%',
    height: 'auto',
    maxHeight: '100%',
    top: '5%',
    // left: '2%',
    backgroundColor: '#fff',
    padding: 0,
    overflow: 'auto',
    outline: 'none',
    borderRadius: 4,
    paddingBottom: 10
  },
  pageTitle: {
    margin: '48px 0px 0px',
    paddingLeft: 20,
    paddingTop: 2,
    textAlign: 'left',
    backgroundColor: '#fff',
    fontSize: 24,
    fontWeight: 700,
    color: '#000000'
  },
  mainPaper: {
    position: 'relative',
    margin: '1px 0px 10px',
    padding: 0,
    boxShadow: 'none',
    color: '#000000'
  },
  textField: {
    padding: '0px',
    width: '100%'
  },
  textFieldLong: {
    padding: '0px',
    width: '100%'
  },
  button: {
    margin: '5px auto'
  },
  priceCalc: {
    margin: '0px 5px',
    color: '#aaa'
  },
  listForm: {
    display: 'block'
  },
  itemForm: {
    display: 'block',
    padding: '20px 20px 12px',
    borderBottom: '1px solid #DDDDDD'
  },
  textExplain: {
    fontSize: 14
  },
  btnBtom: {
    padding: '22px 12px 30px 12px'
  },
  modalMobile: {
    maxWidth: 380,
    margin: 'auto',
    padding: '5% 12px 5%'
  },
  displayFlex: {
    display: 'flex',
    alignItems: 'flex-end'
  },
  displayFlexPulldown: {
    display: 'flex',
    alignItems: 'flex-end',
    width: '100%'
  },
  displayBlock: {
    display: 'block'
  },
  textYen: {
    width: '30px',
    paddingBottom: 4
  },
  textMutiple: {
    // width: '52px',
    fontWeight: 'bold',
    fontSize: 19,
    paddingLeft: 10,
    paddingRight: 10
  },
  textFieldPriceCombo: {
    padding: '0px 5px 0px 5px',
    width: '100%',
    [theme.breakpoints.down('sm')]: {
      width: '100%'
    }
  },
  divisionLabel: {
    fontSize: 12,
    color: 'rgba(0, 0, 0, 0.38)',
    marginTop: 16
  },
  divHelp: {
    marginRight: 'auto'
  },
  iconHelpEx: {
    color: 'gray !important',
    cursor: 'pointer'
  },
  divExplanation: {
    position: 'absolute',
    width: 280,
    top: 53,
    right: 21,
    zIndex: 10
  },
  textHelpExplainDiv: {
    padding: '10px 10px 0 10px'
  },
  textHelpExplain: {
    fontSize: 10
  },
  helpCloseBtn: {
    fontSize: 18,
    position: 'absolute',
    top: 3,
    right: 4,
    cursor: 'pointer'
  },
  helpCloseBtnWhite: {
    color: '#fff !important'
  },
  explainExpirationTitle: {
    fontSize: 10,
    fontWeight: 'bold'
  },
  headerNoteDonation: {
    fontSize: 16,
    fontWeight: 700,
    color: `${theme.palette.primary.main}`
  },
  answerNoteDonation: {
    display: 'flex',
    marginTop: 8
  },
  questionTextDonation: {
    fontSize: 18,
    fontWeight: 400
  },
  answerTextDonation: {
    fontSize: 16,
    fontWeight: 400,
    wordBreak: 'break-all'
  },
  usageTypeText: {
    fontSize: 20,
    fontWeight: 700
  },
  noteLimitTotal: {
    fontSize: 14,
    fontWeight: 400
  },
  qaBox: {
    padding: '20px 20px 8px'
  }
});

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(
    state => ({
      account: state.accounts.account,
      name: state.loginInfo.name,
      detail: state.gochiMenus.detail,
      shops: state.shops.shops,
      // shops: state.options.listShops,
      groups: state.options.listGroups,
      taxTypes: state.gochiMenus.taxTypes,
      reducedTaxMenuPrefix: state.commons.reducedTaxMenuPrefix,
      languages
    }),
    dispatch => ({
      actions: bindActionCreators(
        {
          addGochiMenu,
          addGochiMenuImage
        },
        dispatch
      )
    })
  ),
  setPropTypes(propTypes),
  withState('multiLangData', 'setMultiLangData', {}),
  withState('isLanguage', 'setIsLanguage', 'ja'),
  withState('translateType', 'setTranslateType', 0),
  withState('menuName', 'setMenuName', ''),
  withState('menuNameError', 'setMenuNameError', ''),
  withState('image', 'setImage', null),
  withState('previewImage', 'setPreviewImage', null),
  withState('imageError', 'setImageError', ''),
  withState('isImageDefault', 'setIsImageDefault', false),
  withState('price', 'setPrice', ''),
  withState('priceError', 'setPriceError', ''),
  withState('priceCalc', 'setPriceCalc', '000 (税込み)'),
  withState('taxType', 'setTaxType', 'INTERNAL'),
  withState('reducedTaxCheck', 'setReducedTaxCheck', false),
  withState('reducedTaxType', 'setReducedTaxType', 'UNREDUCED'),
  withState('menuGenreId', 'setMenuGenreId', null),
  withState('menuGenreName', 'setMenuGenreName', ''),
  withState('menuGenreError', 'setMenuGenreError', ''),
  withState('description', 'setDescription', ''),
  withState('tagStr', 'setTagStr', ''),
  withState('tags', 'setTags', null),
  withState('helpExpiration', 'setHelpExpiration', false),
  withState('expirationType', 'setExpirationType', 2),
  withState('expiration', 'setExpiration', ''),
  withState('expirationError', 'setExpirationError', ''),
  withState('expirationEndDate', 'setExpirationEndDate', ''),
  withState('minExpirationDate', 'setMinExpirationDate', () => {
    moment.tz.setDefault('Asia/Tokyo');
    return moment().format('YYYY-MM-DD');
  }),
  withState('maxExpirationDate', 'setMaxExpirationDate', () => {
    moment.tz.setDefault('Asia/Tokyo');
    return moment()
      .add(180, 'days')
      .format('YYYY-MM-DD');
  }),
  withState('expirationList', 'setExpirationList', () => {
    const tmpList = [];
    for (let i = 1; i <= 180; i += 1) {
      tmpList.push({
        label: `${i}日間`,
        value: String(i)
      });
    }
    return tmpList;
  }),
  withState('showQADonation', 'setShowQADonation', false),
  withState('menuLimitTotal', 'setMenuLimitTotal', 0),
  withHandlers({
    checkSession: props => data => {
      if (data.error === true && data.payload.status === 403) {
        sendLogin(props);
      }
      return data;
    }
  }),
  withState(
    'openMenuImageSamplePopup',
    'updateOpenMenuImageSamplePopup',
    false
  ),
  withState('comboMenu', 'setComboMenu', 0),
  withState('helpPriceCombo', 'setHelpPriceCombo', false),
  withState('helpQuantityPromotion', 'setHelpQuantityPromotion', false),
  withState('helpPromotionDescription', 'setHelpPromotionDescription', false),
  withState('helpDonation', 'setHelpDonation', false),
  withState('priceCombo', 'setPriceCombo', ''),
  withState('priceComboError', 'setPriceComboError', ''),
  withState('quantityRelease', 'setQuantityRelease', ''),
  withState('quantityReleaseError', 'setQuantityReleaseError', ''),
  withState('quantityReleaseList', 'setQuantityReleaseList', () => {
    const tmpList = [];
    for (let i = 0; i <= 100; i += 1) {
      tmpList.push({
        label: `${i}`,
        value: String(i)
      });
    }
    return tmpList;
  }),
  withState('quantityPromotion', 'setQuantityPromotion', ''),
  withState('quantityPromotionError', 'setQuantityPromotionError', ''),
  withState('promotionDescription', 'setPromotionDescription', ''),
  withState('usageLimit', 'setUsageLimit', 0),
  withState('openAddConfirm', 'updateOpenAddConfirm', false),
  withState('openAdvancedSetting', 'updateOpenAdvancedSetting', false),
  withState('subscriptionInterval', 'setSubscriptionInterval', 'WEEK'),
  withState('subscriptionIntervalCount', 'setSubscriptionIntervalCount', ''),
  withState('subscription', 'setSubscription', 0),
  withState('subscripIntervalCountError', 'setSubscripIntervalCountError', ''),
  withState('menuSituationIds', 'setmenuSituationIds', []),
  withState('menuUserTargetIds', 'setmenuUserTargetIds', []),
  lifecycle({
    componentDidMount() {
      let dataFirst = {};
      const origilData = {
        menuChildType: null,
        groupId: null,
        shopId: null,
        menuName: null,
        menuLimitTotal: null,
        price: null,
        description: null,
        menuCombo: null,
        priceCombo: null,
        quantity: null,
        quantityFree: null,
        quantityFreeDes: null,
        numberUsePerDay: null,
        expiration: null,
        expirationEndDate: null,
        taxType: null,
        reducedTaxType: null,
        tags: null,
        tagStr: null,
        menuGenreId: null,
        menuGenreName: null,
        usageType: null,
        subscription: null,
        subscriptionIntervalCount: null,
        subscriptionInterval: null,
        menuSituationIds: [],
        menuUserTargetIds: []
      };
      const arr = [];
      languages.forEach(item => {
        if (item.value === languageType.ORIGIN) {
          dataFirst = origilData;
        } else {
          const other = {
            translateType: 0,
            language: item.value
          };
          arr.push(other);
        }
      });
      dataFirst.otherLanguages = arr;
      this.props.setMultiLangData(dataFirst);
      console.log('dataFirst', dataFirst);

      if (this.props.usageType === usageTypes[1].id) {
        this.props.setTagStr(`#${usageTypes[1].name}`);
        this.props.setTags([{ tagName: `#${usageTypes[1].name}` }]);
        this.props.setMenuLimitTotal(1);
      } else if (this.props.usageType === usageTypes[2].id) {
        this.props.setTagStr(`#${usageTypes[2].name}`);
        this.props.setTags([{ tagName: `#${usageTypes[2].name}` }]);
        this.props.setMenuName('GOCHI 回数券');
        this.props.setComboMenu(1);
        this.props.setDescription(
          `${
            this.props.shopName
          }のつかえる回数券です。プレゼントにも、ご自身のためにもお使いいただけます。`
        );
      }
    }
  })
);

const Main = enhance(
  ({
    actions,
    checkSession,
    processBox,
    account,
    updateOpenAdd,
    openAddConfirm,
    updateOpenAddConfirm,
    shopGochiRestriction,
    classes,
    isLanguage,
    translateType,
    usageType,
    menuName,
    setMenuName,
    menuNameError,
    setMenuNameError,
    image,
    setImage,
    previewImage,
    setPreviewImage,
    imageError,
    setImageError,
    price,
    setPrice,
    priceError,
    setPriceError,
    priceCalc,
    setPriceCalc,
    taxType,
    setTaxType,
    taxTypes,
    reducedTaxCheck,
    setReducedTaxCheck,
    reducedTaxType,
    setReducedTaxType,
    menuGenre,
    menuGenreId,
    setMenuGenreId,
    menuGenreName,
    setMenuGenreName,
    menuGenreError,
    setMenuGenreError,
    description,
    setDescription,
    tagStr,
    setTagStr,
    tags,
    setTags,
    helpExpiration,
    setHelpExpiration,
    expirationType,
    setExpirationType,
    expiration,
    setExpiration,
    expirationError,
    setExpirationError,
    expirationEndDate,
    setExpirationEndDate,
    minExpirationDate,
    maxExpirationDate,
    expirationList,
    showQADonation,
    setShowQADonation,
    menuLimitTotal,
    setMenuLimitTotal,
    menuImageSampleList,
    isImageDefault,
    setIsImageDefault,
    openMenuImageSamplePopup,
    updateOpenMenuImageSamplePopup,
    comboMenu,
    helpPriceCombo,
    setHelpPriceCombo,
    helpQuantityPromotion,
    setHelpQuantityPromotion,
    helpPromotionDescription,
    setHelpPromotionDescription,
    helpDonation,
    setHelpDonation,
    priceCombo,
    setPriceCombo,
    priceComboError,
    setPriceComboError,
    quantityRelease,
    quantityReleaseList,
    setQuantityRelease,
    quantityReleaseError,
    setQuantityReleaseError,
    quantityPromotion,
    setQuantityPromotion,
    quantityPromotionError,
    setQuantityPromotionError,
    promotionDescription,
    setPromotionDescription,
    usageLimit,
    setUsageLimit,
    shopId,
    shopName,
    multiLangData,
    setMultiLangData,
    reducedTaxMenuPrefix,
    openAdvancedSetting,
    updateOpenAdvancedSetting,
    subscriptionInterval,
    // setSubscriptionInterval,
    subscriptionIntervalCount,
    // setSubscriptionIntervalCount,
    subscription,
    // setSubscription,
    subscripIntervalCountError,
    setSubscripIntervalCountError,
    menuSituationIds,
    menuUserTargetIds
  }) => {
    const USAGE_TYPE_MENU = usageTypes[0].id;
    const USAGE_TYPE_VOUCHER = usageTypes[1].id;
    const USAGE_TYPE_COMBO = usageTypes[2].id;
    const IMAGE_DEFAULT_VOUCHER = '/images/background_voucher.png';
    const IMAGE_DEFAULT_COMBO = '/images/background_combo.png';
    const errors = {
      menuNameError,
      priceError,
      menuGenreError,
      expirationError,
      priceComboError,
      quantityReleaseError,
      quantityPromotionError,
      imageError,
      subscripIntervalCountError
    };

    const addWaterMark = async inputPrice => {
      const canvas = await new Promise(resolve => {
        let objectURL = '';
        if (usageType === USAGE_TYPE_VOUCHER) {
          objectURL = IMAGE_DEFAULT_VOUCHER;
        } else if (usageType === USAGE_TYPE_COMBO) {
          objectURL = IMAGE_DEFAULT_COMBO;
        }
        const c = document.createElement('canvas');
        const ctx = c.getContext('2d');
        const img = new Image();

        img.onload = () => {
          ctx.canvas.width = img.width;
          ctx.canvas.height = img.height;
          ctx.drawImage(img, 0, 0, img.width, img.height);
          ctx.fillStyle = 'black';
          ctx.font =
            "700 100px 'Yu Gothic', 'Roboto', 'Helvetica', 'Arial', sans-serif";
          const tempPrice = parseInt(inputPrice, 10);
          const textString = isNaN(tempPrice)
            ? ''
            : `${tempPrice.toLocaleString()}${
                usageType === USAGE_TYPE_VOUCHER ? '円' : '円分'
              }`;
          const textWidth = ctx.measureText(textString).width;
          ctx.fillText(
            textString,
            ctx.canvas.width / 2 - textWidth / 2,
            ctx.canvas.height / 2
          );
          resolve(c);
        };
        img.src = objectURL;
        console.log('objectURL', objectURL);
      });

      return new Promise(resolve => {
        canvas.toBlob(
          newblob => {
            resolve(newblob);
          },
          'image/png',
          1
        );
      });
    };

    const renderImageDefault = async (inputPrice, isClick) => {
      // handle asynchronous when render image from price
      window.priceRenderImageMenu = inputPrice;
      let fileName = '';
      if (!isImageDefault && previewImage && !isClick) {
        return;
      }
      if (usageType === USAGE_TYPE_VOUCHER) {
        fileName = `${shopName}の${inputPrice}円商品券`;
      } else if (usageType === USAGE_TYPE_COMBO) {
        fileName = `${shopName}の${inputPrice}円回数券`;
      }
      const newBlob = await addWaterMark(inputPrice);
      const blob = new Blob([newBlob], { type: 'image/png' });
      const newImage = new File([blob], `${fileName}.png`, {
        type: blob.type
      });
      const reader = new FileReader();
      reader.readAsDataURL(newImage);
      setImage(newImage);
      setIsImageDefault(true);
      setImageError('');
      reader.onloadend = () => {
        if (inputPrice === window.priceRenderImageMenu) {
          setPreviewImage(reader.result);
        }
      };
    };

    const autoRenderDescription = () => {
      if (usageType === USAGE_TYPE_COMBO) {
        if (
          quantityPromotion &&
          quantityPromotion !== '0' &&
          promotionDescription
        ) {
          setDescription(
            `${shopName}のつかえる回数券です。無料で${quantityPromotion}枚が追加されます。${promotionDescription}がつきます。プレゼントにも、ご自身のためにもお使いいただけます。`
          );
        } else if (quantityPromotion && quantityPromotion !== '0') {
          setDescription(
            `${shopName}のつかえる回数券です。無料で${quantityPromotion}枚が追加されます。プレゼントにも、ご自身のためにもお使いいただけます。`
          );
        } else if (promotionDescription) {
          setDescription(
            `${shopName}のつかえる回数券です。${promotionDescription}がつきます。プレゼントにも、ご自身のためにもお使いいただけます。`
          );
        } else {
          setDescription(
            `${shopName}のつかえる回数券です。プレゼントにも、ご自身のためにもお使いいただけます。`
          );
        }
      }
    };

    useEffect(() => {
      autoRenderDescription();
    }, [quantityPromotion, promotionDescription]);

    const cancelAction = () => {
      updateOpenAdd(false);
    };

    const getUsageTypeName = usageTypeId => {
      if (usageTypeId) {
        const usageTypeName = usageTypes.find(
          usage => usage.id.toString() === usageTypeId.toString()
        ).name;
        return usageTypeName;
      }
      return '';
    };

    const getGenreName = () => {
      if (menuGenreId) {
        const genreName = menuGenre.find(
          genre => genre.menuGenreId.toString() === menuGenreId.toString()
        ).menuGenreName;
        return genreName;
      }
      return '';
    };

    const convertReducedTax = checked => {
      if (checked) {
        setReducedTaxType('REDUCED');
      } else {
        setReducedTaxType('UNREDUCED');
      }
    };

    const calcPrice = e => {
      let includedTaxPrice = '';
      let excludedTaxPrice = '';

      let latestPrice = price;
      if (e.target.id === 'price') {
        latestPrice = e.target.value;
      }

      let latestTaxType = taxType;
      if (e.target.name === 'taxType') {
        latestTaxType = e.target.value;
      }

      if (e.target.id === 'isDonation') {
        if (e.target.checked) {
          latestTaxType = 'DONATION';
        } else {
          latestTaxType = 'INTERNAL';
        }
      }

      let lastestPriceCombo = priceCombo;
      if (e.target.id === 'priceCombo') {
        lastestPriceCombo = e.target.value;
      }

      let lastestQuantityRelease = quantityRelease;
      if (e.target.name === 'quantityRelease') {
        lastestQuantityRelease = e.target.value;
      }

      if (
        lastestPriceCombo &&
        lastestPriceCombo !== '' &&
        lastestQuantityRelease &&
        lastestQuantityRelease !== ''
      ) {
        setPrice(lastestPriceCombo * lastestQuantityRelease);
        renderImageDefault(lastestPriceCombo * lastestQuantityRelease, false);
        latestPrice = lastestPriceCombo * lastestQuantityRelease;
      }
      if (
        (!lastestPriceCombo ||
          lastestPriceCombo === '' ||
          !lastestQuantityRelease ||
          lastestQuantityRelease === '') &&
        comboMenu === 1
      ) {
        setPrice(lastestPriceCombo * lastestQuantityRelease);
        renderImageDefault(lastestPriceCombo * lastestQuantityRelease, false);
        setPriceCalc('000 (税込み)');
        latestPrice = lastestPriceCombo * lastestQuantityRelease;
      }

      // TODO DBから取得
      let tax = 0.1;
      if (
        (e.target.id !== 'reducedTax' && reducedTaxCheck) ||
        (e.target.id === 'reducedTax' && e.target.checked)
      ) {
        // TODO DBから取得
        tax = 0.08;
      }

      if (latestPrice !== '') {
        if (latestTaxType === 'INTERNAL') {
          const amountTemp = parseFloat((latestPrice / (1 + tax)).toFixed(9));
          const taxAmount = Math.round(amountTemp * tax);
          includedTaxPrice = latestPrice;
          excludedTaxPrice = latestPrice - taxAmount;
        } else if (latestTaxType === 'DONATION') {
          includedTaxPrice = latestPrice;
          excludedTaxPrice = latestPrice;
        } else {
          const taxAmount = Math.round(latestPrice * tax);
          includedTaxPrice = latestPrice * 1 + taxAmount;
          excludedTaxPrice = latestPrice;
        }
      }
      console.log(excludedTaxPrice);
      // setPriceCalc(`${includedTaxPrice} (税抜 ${excludedTaxPrice})`);
      console.log('e.target.id', e.target.id);
      const val =
        e.target.id !== 'reducedTax' &&
        typeof e.target.id !== 'undefined' &&
        e.target.id !== 'isDonation'
          ? e.target.value
          : includedTaxPrice;
      console.log('val', val);
      const priceShow =
        val !== '' ? parseInt(includedTaxPrice, 0).toString() : '000';
      setPriceCalc(`${priceShow} (税込み)`);
    };

    const splitTagStr = str => {
      if (str === '') {
        setTags(null);
      } else {
        setTags(
          str.split(/\s+/).map(t => {
            return { tagName: t };
          })
        );
      }
    };

    const resetExpirationValue = () => {
      setExpiration('');
      setExpirationEndDate('');
    };

    const handleAddImage = imageInput => {
      setPreviewImage(imageInput);
      setIsImageDefault(false);
      setImageError('');
    };

    const handleShowHelpExpiration = () => {
      setHelpExpiration(true);
    };

    const handleShowHelpPriceCombo = () => {
      setHelpPriceCombo(true);
    };

    const handleShowHelpQuantityPromotion = () => {
      setHelpQuantityPromotion(true);
    };

    const handleShowHelpPromotionDescription = () => {
      setHelpPromotionDescription(true);
    };

    const handleShowHelpDonation = () => {
      setHelpDonation(true);
    };

    const handleCloseHelpPopup = () => {
      setHelpPriceCombo(false);
      setHelpQuantityPromotion(false);
      setHelpPromotionDescription(false);
      setHelpExpiration(false);
      setHelpDonation(false);
    };

    const ref = useRef();

    const handleClose = e => {
      if (helpPriceCombo) {
        if (ref.current && !ref.current.contains(e.target)) {
          setHelpPriceCombo(false);
        }
      }
      if (helpQuantityPromotion) {
        if (ref.current && !ref.current.contains(e.target)) {
          setHelpQuantityPromotion(false);
        }
      }
      if (helpPromotionDescription) {
        if (ref.current && !ref.current.contains(e.target)) {
          setHelpPromotionDescription(false);
        }
      }
      if (helpExpiration) {
        if (ref.current && !ref.current.contains(e.target)) {
          setHelpExpiration(false);
        }
      }
      if (helpDonation) {
        if (ref.current && !ref.current.contains(e.target)) {
          setHelpDonation(false);
        }
      }
    };

    useEffect(() => {
      document.addEventListener('click', handleClose);
      return () => {
        document.removeEventListener('click', handleClose);
      };
    });

    const validMenuName = () => {
      if (isLanguage !== languageType.ORIGIN && translateType === 0) {
        return 0;
      }
      const value = menuName;
      if (value.trim() === '') {
        setMenuNameError('必須項目です。');
        return 1;
      }
      setMenuNameError('');
      setMenuName(value);
      return 0;
    };

    const validPrice = () => {
      const value = price;
      if (value === '') {
        setPriceError('必須項目です。');
        return 1;
      }
      if (!/^\d+$/.test(value)) {
        setPriceError('半角数字のみ入力してください。');
        return 1;
      }
      if (parseInt(value, 10) > 999999999) {
        setPriceError('999,999,999円以下ご入力ください。');
        return 1;
      }
      setPriceError('');
      setPrice(value);
      return 0;
    };

    const validMenuGenre = () => {
      const value = menuGenreId;
      if (!value) {
        setMenuGenreError('必須項目です。');
        return 1;
      }
      setMenuGenreError('');
      setMenuGenreId(value);
      return 0;
    };

    const validImageMenu = () => {
      const value = previewImage;
      if (!value) {
        setImageError('必須項目です。');
        return 1;
      }
      setImageError('');
      return 0;
    };

    const validExpiration = () => {
      const value = expiration;
      if (value === '') {
        setExpirationError('');
        return 0;
      }
      if (!/\b([1-9]|[1-9][0-9]|1[0-7][0-9]|180)\b/.test(value)) {
        setExpirationError('半角数字のみ入力してください。From 1 - 180');
        return 1;
      }
      setExpirationError('');
      setExpiration(parseInt(value, 10));
      return 0;
    };

    const validPriceCombo = () => {
      const value = priceCombo;
      if (value === '') {
        setPriceComboError('必須項目です。');
        return 1;
      }
      if (!/^\d+$/.test(value)) {
        setPriceComboError('半角数字のみ入力してください。');
        return 1;
      }
      setPriceComboError('');
      setPriceCombo(parseInt(value, 10));
      return 0;
    };

    const validQuantityRelease = () => {
      const value = quantityRelease;
      if (value === '') {
        setQuantityReleaseError('必須項目です。');
        return 1;
      }
      if (!/^[1-9]|[1-9]\d+$/.test(value)) {
        setQuantityReleaseError('半角数字のみ入力してください。');
        return 1;
      }
      setQuantityReleaseError('');
      setQuantityRelease(parseInt(value, 10));
      return 0;
    };

    const validQuantityPromotion = () => {
      const value = quantityPromotion;
      if (value === '') {
        setQuantityPromotionError('');
        return 0;
      }
      if (!/^\d+$/.test(value)) {
        setQuantityPromotionError('半角数字のみ入力してください。');
        return 1;
      }
      setQuantityPromotionError('');
      setQuantityPromotion(parseInt(value, 10));
      return 0;
    };

    const validSubscriptionIntervalCount = () => {
      const checkSubscription = subscription;
      if (checkSubscription === 1) {
        const valueIntervalCount = subscriptionIntervalCount;
        const valueInterval = subscriptionInterval;
        if (valueIntervalCount === '') {
          setSubscripIntervalCountError('必須項目です。');
          return 1;
        }
        if (Number(valueIntervalCount) < 1) {
          setSubscripIntervalCountError('頻度価値は1以上ご入力ください');
          return 1;
        }
        if (!/^\d+$/.test(valueIntervalCount)) {
          setSubscripIntervalCountError('半角数字のみ入力してください。');
          return 1;
        }
        if (valueInterval === 'WEEK' && Number(valueIntervalCount) > 52) {
          setSubscripIntervalCountError(
            '頻度価値は週間サブスクに対して52以下、月間サブスクに対して12以下入力してください。'
          );
          return 1;
        }
        if (valueInterval === 'MONTH' && Number(valueIntervalCount) > 12) {
          setSubscripIntervalCountError(
            '頻度価値は週間サブスクに対して52以下、月間サブスクに対して12以下入力してください。'
          );
          return 1;
        }
      }
      setSubscripIntervalCountError('');
      return 0;
    };

    const valid = () => {
      let errorCount = 0;
      const validMenuNameCount = validMenuName();
      const validImageMenuCount =
        usageType === USAGE_TYPE_MENU ? 0 : validImageMenu();
      if (usageType !== USAGE_TYPE_COMBO) {
        errorCount =
          validMenuNameCount +
          validPrice() +
          validMenuGenre() +
          validImageMenuCount +
          validExpiration() +
          validSubscriptionIntervalCount();
      } else {
        errorCount =
          validMenuNameCount +
          validPriceCombo() +
          validQuantityRelease() +
          validQuantityPromotion() +
          validExpiration() +
          validMenuGenre() +
          validImageMenuCount +
          validSubscriptionIntervalCount();
      }

      if (
        (validMenuNameCount > 0 || validImageMenuCount > 0) &&
        usageType !== USAGE_TYPE_MENU
      ) {
        updateOpenAdvancedSetting(true);
      }

      if (errorCount === 0) {
        return true;
      }
      return false;
    };

    const getCurrentData = () => {
      const lang = isLanguage;
      let data = multiLangData;
      const origilParam = {
        menuChildType: 1,
        shopId,
        menuName,
        price,
        description,
        menuCombo: comboMenu,
        menuLimitTotal:
          usageType === USAGE_TYPE_VOUCHER ? menuLimitTotal : undefined,
        priceCombo,
        quantity: quantityRelease,
        quantityFree: quantityPromotion,
        quantityFreeDes: promotionDescription,
        numberUsePerDay: usageLimit,
        expiration,
        expirationEndDate,
        taxType,
        reducedTaxType,
        tags,
        tagStr,
        previewImage,
        menuGenreId,
        usageType,
        subscription,
        subscriptionIntervalCount:
          subscription === 1 ? subscriptionIntervalCount : undefined,
        subscriptionInterval:
          subscription === 1 ? subscriptionInterval : undefined,
        menuSituationIds,
        menuUserTargetIds
      };
      const otherParam = {
        translateType,
        language: lang,
        params: {
          menuName,
          description,
          quantityFreeDes: promotionDescription
        }
      };
      // origin
      if (lang === languageType.ORIGIN) {
        data = { ...data, ...origilParam };
      } else {
        // other languages
        for (let index = 0; index < data.otherLanguages.length; index += 1) {
          if (data.otherLanguages[index].language === lang) {
            data.otherLanguages[index] = otherParam;
          }
        }
      }
      console.log('GET CURRENT DATA: ', data);
      const str = JSON.stringify(data);
      return JSON.parse(str);
    };

    const confirmAction = () => {
      if (!valid()) {
        alert('登録情報を正しく入力してください。');
      } else {
        setMenuGenreName(getGenreName());
        setMultiLangData(getCurrentData());
        updateOpenAddConfirm(true);
      }
    };

    const registerAction = async () => {
      processBox.setLoading(true);
      processBox.updateOpenProgress(true);
      let params = {};
      if (account.fukuokaFlag) {
        params = {
          ...multiLangData,
          shashokuOn: 1,
          gochimeshiOn: 0
        };
      } else {
        params = {
          ...multiLangData,
          shashokuOn:
            !multiLangData.menuCombo && !multiLangData.menuLimitTotal ? 1 : 0
        };
      }
      const addedMenu = await actions
        .addGochiMenu(params)
        .then(data => checkSession(data));
      if (addedMenu.type === ADD_GOCHI_MENU_SUCCESS) {
        if (image !== null) {
          let imageData = image;
          if (imageData.size > Number(process.env.REACT_APP_RESIZE_BORDER)) {
            const { resizeImageFile } = await resizeImage(imageData);
            imageData = resizeImageFile;
          }
          const imagePath = await uploadFile(
            'menu',
            addedMenu.payload.menuId,
            imageData,
            'public'
          );
          await actions
            .addGochiMenuImage(addedMenu.payload.menuId, {
              image: imagePath
            })
            .then(data => checkSession(data));
        }
        processBox.setMessage('登録が完了しました。');
      } else {
        processBox.setErrorMessage('登録に失敗しました。');
        processBox.updateOpenProgress(false);
      }
      processBox.setLoading(false);
    };

    return (
      <>
        <div className={classes.root}>
          <div>
            <Typography className={classes.pageTitle}>
              メニュー追加（2/2）
            </Typography>
          </div>
          <Paper className={classes.mainPaper} elevation={1}>
            <List component="nav" className={classes.listForm}>
              {isLanguage === languageType.ORIGIN && (
                <>
                  <ListItem style={{ padding: '24px 20px 4px' }}>
                    <Typography
                      component="div"
                      className={classNames(
                        classes.labelControl,
                        classes.usageTypeText
                      )}
                    >
                      {`用途: ${getUsageTypeName(usageType)}`}
                    </Typography>
                  </ListItem>
                  {usageType === USAGE_TYPE_MENU && (
                    <>
                      <ListItem className={classes.itemForm}>
                        <Typography
                          component="div"
                          className={classes.labelControl}
                        >
                          <RequiredButton />
                        </Typography>
                        <Typography
                          component="div"
                          className={classes.formInput}
                        >
                          <TextField
                            required
                            label="メニュー名"
                            className={classes.textField}
                            margin="normal"
                            value={menuName}
                            inputProps={{
                              maxLength:
                                isLanguage === languageType.ORIGIN ? 100 : 250
                            }}
                            disabled={
                              isLanguage !== languageType.ORIGIN &&
                              translateType === 0
                            }
                            onChange={e => {
                              setMenuName(e.target.value);
                            }}
                            onBlur={validMenuName}
                          />
                          {(isLanguage === languageType.ORIGIN ||
                            translateType === 1) && (
                            <ValidationText message={errors.menuNameError} />
                          )}
                        </Typography>
                      </ListItem>
                      <ListItem className={classes.itemForm}>
                        <Typography
                          component="div"
                          className={classes.labelControl}
                        >
                          <AnyButton />
                        </Typography>
                        <Typography
                          component="div"
                          className={classes.formInput}
                        >
                          <div style={{ marginTop: 16, fontSize: 14 }}>
                            メニュー画像
                          </div>
                          {/* <Button
                            variant="outlined"
                            color="primary"
                            component="span"
                            className={classes.button}
                            onClick={() => updateOpenMenuImageSamplePopup(true)}
                          >
                            デフォルト画像を選択
                          </Button> */}
                          <FileUpload
                            label="image"
                            setFile={setImage}
                            previewImage={previewImage}
                            setPreviewImage={handleAddImage}
                            isOnlyImage
                          />
                          <div className={classes.textExplain}>
                            ※8MB以内でお願いします。
                          </div>
                        </Typography>
                      </ListItem>
                    </>
                  )}
                  {usageType === USAGE_TYPE_COMBO ? (
                    <ListItem className={classes.itemForm}>
                      <Typography
                        component="div"
                        className={classes.labelControl}
                      >
                        <div className={classes.displayFlex}>
                          <div className={classes.divHelp}>
                            <RequiredButton />
                          </div>
                          <HelpIcon
                            className={classes.iconHelpEx}
                            onClick={handleShowHelpPriceCombo}
                          />
                          {helpPriceCombo && (
                            <div ref={ref} className={classes.divExplanation}>
                              <Card>
                                <CardMedia
                                  component="img"
                                  width="280"
                                  className={classes.media}
                                  image="images/help_comboPrice.png"
                                  title="Menu price explaination"
                                />
                                <CloseIcon
                                  className={[
                                    classes.helpCloseBtn,
                                    classes.helpCloseBtnWhite
                                  ]}
                                  onClick={handleCloseHelpPopup}
                                />
                                <CardContent
                                  className={classes.textHelpExplainDiv}
                                >
                                  <Typography
                                    variant="body2"
                                    component="p"
                                    className={classes.textHelpExplain}
                                  >
                                    メニュー名の後に表示される回数券の「単価」と「発行枚数」です。
                                  </Typography>
                                </CardContent>
                              </Card>
                            </div>
                          )}
                        </div>
                      </Typography>
                      <Typography component="div" className={classes.formInput}>
                        <Typography className={classes.divisionLabel}>
                          単価×発行枚数
                        </Typography>
                        <div className={classes.displayFlex}>
                          <div className={classes.displayFlex}>
                            <TextField
                              id="priceCombo"
                              required
                              label="単価"
                              className={classes.textFieldPriceCombo}
                              margin="normal"
                              value={priceCombo}
                              onChange={e => {
                                setPriceCombo(e.target.value.trim());
                                calcPrice(e);
                              }}
                              onBlur={validPriceCombo}
                            />
                          </div>
                          <div className={classes.textYen}>円</div>
                          <div className={classes.textMutiple}>×</div>
                          <div className={classes.displayFlexPulldown}>
                            <TextField
                              id="quantityRelease"
                              name="quantityRelease"
                              select
                              required
                              label="発行枚数"
                              className={classes.textFieldPriceCombo}
                              margin="normal"
                              value={quantityRelease}
                              InputProps={{
                                shrink: true
                              }}
                              onChange={e => {
                                setQuantityRelease(e.target.value.trim());
                                calcPrice(e);
                              }}
                              onBlur={validQuantityRelease}
                            >
                              {quantityReleaseList.map(item => {
                                return (
                                  <MenuItem key={item.value} value={item.value}>
                                    {item.label}
                                  </MenuItem>
                                );
                              })}
                            </TextField>
                            <div className={classes.textYen}>枚</div>
                          </div>
                        </div>
                        <div className={classes.displayBlock}>
                          <ValidationText message={errors.priceComboError} />
                          <ValidationText
                            message={errors.quantityReleaseError}
                          />
                        </div>
                      </Typography>
                    </ListItem>
                  ) : (
                    <ListItem className={classes.itemForm}>
                      <Typography
                        component="div"
                        className={classes.labelControl}
                      >
                        <RequiredButton />
                      </Typography>
                      <Typography component="div" className={classes.formInput}>
                        <TextField
                          required
                          id="price"
                          label="価格"
                          className={classes.textField}
                          margin="normal"
                          value={price}
                          onChange={e => {
                            const tempPrice = e.target.value.trim();
                            setPrice(tempPrice);
                            calcPrice(e);
                            if (usageType === USAGE_TYPE_VOUCHER) {
                              const priceText = isNaN(parseInt(tempPrice, 10))
                                ? ''
                                : parseInt(tempPrice, 10).toLocaleString();
                              renderImageDefault(tempPrice, false);
                              setMenuName(`GOCHI ${priceText}円券`);
                              setMenuNameError('');
                              setDescription(
                                `${shopName}の${priceText}円分使える商品券です。プレゼントにどうぞ。`
                              );
                            }
                          }}
                          onBlur={validPrice}
                          disabled={usageType === USAGE_TYPE_COMBO}
                        />
                        <ValidationText message={errors.priceError} />
                        <div className={classes.priceCalc}>{priceCalc}</div>
                      </Typography>
                    </ListItem>
                  )}
                  <ListItem className={classes.itemForm}>
                    <Typography
                      component="div"
                      className={classes.labelControl}
                    >
                      <RequiredButton />
                    </Typography>
                    <Typography component="div" className={classes.formInput}>
                      <div>
                        <TextField
                          required
                          id="taxType"
                          name="taxType"
                          select
                          label="税区分"
                          className={classes.textField}
                          margin="normal"
                          value={taxType === 'DONATION' ? 'INTERNAL' : taxType}
                          onChange={e => {
                            setTaxType(e.target.value.trim());
                            calcPrice(e);
                          }}
                          InputLabelProps={{
                            shrink: true
                          }}
                          disabled={
                            taxType === 'DONATION' ||
                            usageType !== USAGE_TYPE_MENU
                          }
                        >
                          {taxTypes
                            .filter(group => {
                              return group.id !== 'DONATION';
                            })
                            .map(group => {
                              return (
                                <MenuItem key={group.id} value={group.id}>
                                  {group.name}
                                </MenuItem>
                              );
                            })}
                        </TextField>
                      </div>
                      {usageType === USAGE_TYPE_MENU && (
                        <>
                          <FormControlLabel
                            control={
                              <Checkbox id="reducedTax" color="primary" />
                            }
                            label="軽減税率対象"
                            checked={reducedTaxCheck}
                            onChange={e => {
                              setReducedTaxCheck(e.target.checked);
                              convertReducedTax(e.target.checked);
                              calcPrice(e);
                            }}
                          />
                          <div style={{ fontSize: 14 }}>
                            価格の消費税の設定をお願いします。
                            <br />
                            ・外税
                            <br />
                            ・内税
                            <br />
                            ※テイクアウトの場合は、「軽減税率対象」にチェックを入れてください。
                          </div>
                        </>
                      )}
                    </Typography>
                  </ListItem>
                  {usageType === USAGE_TYPE_COMBO && (
                    <>
                      <ListItem className={classes.itemForm}>
                        <Typography
                          component="div"
                          className={classes.labelControl}
                        >
                          <div className={classes.displayFlex}>
                            <div className={classes.divHelp}>
                              <AnyButton />
                            </div>
                            <HelpIcon
                              className={classes.iconHelpEx}
                              onClick={handleShowHelpQuantityPromotion}
                            />
                            {helpQuantityPromotion && (
                              <div ref={ref} className={classes.divExplanation}>
                                <Card>
                                  <CardMedia
                                    component="img"
                                    width="280"
                                    className={classes.media}
                                    image="images/help_quantityPromotion.png"
                                    title="Quantity promotion explaination"
                                  />
                                  <CloseIcon
                                    className={[
                                      classes.helpCloseBtn,
                                      classes.helpCloseBtnWhite
                                    ]}
                                    onClick={handleCloseHelpPopup}
                                  />
                                  <CardContent
                                    className={classes.textHelpExplainDiv}
                                  >
                                    <Typography
                                      variant="body2"
                                      component="p"
                                      className={classes.textHelpExplain}
                                    >
                                      メニュー画像とおまけの下の２箇所に表示される回数券の「付与無料枚数」です。
                                    </Typography>
                                  </CardContent>
                                </Card>
                              </div>
                            )}
                          </div>
                        </Typography>
                        <Typography
                          component="div"
                          className={classes.formInput}
                        >
                          <TextField
                            id="quantityPromotion"
                            name="quantityPromotion"
                            select
                            label="付与無料枚数"
                            className={classes.textFieldLong}
                            margin="normal"
                            InputProps={{
                              shrink: true
                            }}
                            value={quantityPromotion}
                            onChange={e => {
                              setQuantityPromotion(e.target.value);
                            }}
                            onBlur={validQuantityPromotion}
                          >
                            {quantityReleaseList.map(item => {
                              return (
                                <MenuItem key={item.value} value={item.value}>
                                  {item.label}
                                </MenuItem>
                              );
                            })}
                          </TextField>
                          <ValidationText
                            message={errors.quantityPromotionError}
                          />
                        </Typography>
                      </ListItem>
                      <ListItem className={classes.itemForm}>
                        <Typography
                          component="div"
                          className={classes.labelControl}
                        >
                          <div className={classes.displayFlex}>
                            <div className={classes.divHelp}>
                              <AnyButton />
                            </div>
                            <HelpIcon
                              className={classes.iconHelpEx}
                              onClick={handleShowHelpPromotionDescription}
                            />
                            {helpPromotionDescription && (
                              <div ref={ref} className={classes.divExplanation}>
                                <Card>
                                  <CardMedia
                                    component="img"
                                    width="280"
                                    className={classes.media}
                                    image="images/help_quantityPromotionDescription.png"
                                    title="Quantity promotion description explaination"
                                  />
                                  <CloseIcon
                                    className={[
                                      classes.helpCloseBtn,
                                      classes.helpCloseBtnWhite
                                    ]}
                                    onClick={handleCloseHelpPopup}
                                  />
                                  <CardContent
                                    className={classes.textHelpExplainDiv}
                                  >
                                    <Typography
                                      variant="body2"
                                      component="p"
                                      className={classes.textHelpExplain}
                                    >
                                      メニューの説明文の下に表示される「おまけ」欄です。
                                    </Typography>
                                  </CardContent>
                                </Card>
                              </div>
                            )}
                          </div>
                        </Typography>
                        {/* quantityFreeDes input  */}
                        <Typography
                          component="div"
                          className={classes.formInput}
                        >
                          <TextField
                            label="おまけ"
                            // multiline
                            // rows="3"
                            className={classes.textFieldLong}
                            margin="normal"
                            value={promotionDescription}
                            inputProps={{
                              maxLength:
                                isLanguage === languageType.ORIGIN ? 1000 : 2500
                            }}
                            disabled={
                              isLanguage !== languageType.ORIGIN &&
                              translateType === 0
                            }
                            onChange={e => {
                              setPromotionDescription(e.target.value);
                            }}
                          />
                        </Typography>
                      </ListItem>
                    </>
                  )}
                  <ListItem className={classes.itemForm}>
                    <Typography
                      component="div"
                      className={classes.labelControl}
                    >
                      <RequiredButton />
                    </Typography>
                    <Typography component="div" className={classes.formInput}>
                      <TextField
                        required
                        select
                        label="ジャンル"
                        className={classes.textField}
                        margin="normal"
                        value={menuGenreId}
                        onChange={e => {
                          setMenuGenreId(e.target.value);
                        }}
                        InputLabelProps={{
                          shrink: true
                        }}
                        onBlur={validMenuGenre}
                      >
                        {menuGenre &&
                          menuGenre.map(item => {
                            return (
                              <MenuItem
                                key={item.menuGenreId}
                                value={item.menuGenreId}
                              >
                                {item.menuGenreName}
                              </MenuItem>
                            );
                          })}
                      </TextField>
                      <ValidationText message={errors.menuGenreError} />
                    </Typography>
                  </ListItem>
                  {usageType === USAGE_TYPE_MENU && (
                    <ListItem className={classes.itemForm}>
                      <Typography
                        component="div"
                        className={classes.labelControl}
                      >
                        <AnyButton />
                      </Typography>
                      <Typography component="div" className={classes.formInput}>
                        <TextField
                          label="説明"
                          multiline
                          rows="4"
                          inputProps={{
                            maxLength:
                              isLanguage === languageType.ORIGIN ? 1000 : 2500
                          }}
                          disabled={
                            isLanguage !== languageType.ORIGIN &&
                            translateType === 0
                          }
                          className={classes.textFieldLong}
                          margin="normal"
                          onChange={e => {
                            setDescription(e.target.value);
                          }}
                          value={description}
                        />
                      </Typography>
                    </ListItem>
                  )}
                  <ListItem className={classes.itemForm}>
                    <Typography
                      component="div"
                      className={classes.labelControl}
                    >
                      <AnyButton />
                    </Typography>
                    <Typography component="div" className={classes.formInput}>
                      <TextField
                        label="タグ"
                        className={classes.textFieldLong}
                        margin="normal"
                        value={tagStr}
                        onChange={e => {
                          setTagStr(e.target.value);
                          splitTagStr(e.target.value);
                        }}
                      />
                    </Typography>
                    <Typography component="div" className={classes.textExplain}>
                      #おすすめ #おふくろの味 #学生に ＃ガッツリ
                      などメニューの特徴を表すタグを記載できます。
                    </Typography>
                  </ListItem>
                  <ListItem>
                    <Typography
                      component="div"
                      className={classes.labelControl}
                      style={{ width: '100%' }}
                    >
                      <div
                        className={classes.displayFlex}
                        onClick={() =>
                          updateOpenAdvancedSetting(!openAdvancedSetting)
                        }
                        aria-hidden="true"
                        style={{ cursor: 'pointer', alignItems: 'flex-start' }}
                      >
                        <div
                          style={{
                            fontSize: 20,
                            fontWeight: 700
                          }}
                          className={classes.divHelp}
                        >
                          高度な設定
                        </div>
                        {openAdvancedSetting ? (
                          <KeyboardArrowUp />
                        ) : (
                          <KeyboardArrowDown />
                        )}
                      </div>
                      <div style={{ marginTop: 8 }}>
                        以下の高度な設定は必須ではありません。詳細設定を希望される場合のみご利用ください。高度な設定により、ご利用条件・ご利用期間などが異なります。項目の詳細を十分にご理解いただいたうえで、設定をお願いいたします。
                      </div>
                    </Typography>
                  </ListItem>
                  {openAdvancedSetting && (
                    <>
                      {usageType !== USAGE_TYPE_MENU && (
                        <>
                          <ListItem className={classes.itemForm}>
                            <Typography
                              component="div"
                              className={classes.labelControl}
                            >
                              <RequiredButton />
                            </Typography>
                            <Typography
                              component="div"
                              className={classes.formInput}
                            >
                              <TextField
                                required
                                label="メニュー名"
                                className={classes.textField}
                                margin="normal"
                                value={menuName}
                                inputProps={{
                                  maxLength:
                                    isLanguage === languageType.ORIGIN
                                      ? 100
                                      : 250
                                }}
                                disabled={
                                  isLanguage !== languageType.ORIGIN &&
                                  translateType === 0
                                }
                                onChange={e => {
                                  setMenuName(e.target.value);
                                }}
                                onBlur={validMenuName}
                              />
                              {(isLanguage === languageType.ORIGIN ||
                                translateType === 1) && (
                                <ValidationText
                                  message={errors.menuNameError}
                                />
                              )}
                            </Typography>
                          </ListItem>
                          <ListItem className={classes.itemForm}>
                            <Typography
                              component="div"
                              className={classes.labelControl}
                            >
                              <RequiredButton />
                            </Typography>
                            <Typography
                              component="div"
                              className={classes.formInput}
                            >
                              <div>メニュー画像</div>
                              {!isImageDefault && (
                                <Button
                                  variant="outlined"
                                  color="primary"
                                  component="span"
                                  className={classes.button}
                                  onClick={() =>
                                    renderImageDefault(price, true)
                                  }
                                  disabled={price === ''}
                                >
                                  デフォルト画像を選択
                                </Button>
                              )}
                              <FileUpload
                                label="image"
                                setFile={setImage}
                                previewImage={previewImage}
                                setPreviewImage={handleAddImage}
                                isOnlyImage
                              />
                              <ValidationText message={errors.imageError} />
                              <div className={classes.textExplain}>
                                ※8MB以内でお願いします。
                              </div>
                            </Typography>
                          </ListItem>
                          <ListItem className={classes.itemForm}>
                            <Typography
                              component="div"
                              className={classes.labelControl}
                            >
                              <AnyButton />
                            </Typography>
                            <Typography
                              component="div"
                              className={classes.formInput}
                            >
                              <TextField
                                label="説明"
                                multiline
                                rows="4"
                                inputProps={{
                                  maxLength:
                                    isLanguage === languageType.ORIGIN
                                      ? 1000
                                      : 2500
                                }}
                                disabled={
                                  isLanguage !== languageType.ORIGIN &&
                                  translateType === 0
                                }
                                className={classes.textFieldLong}
                                margin="normal"
                                onChange={e => {
                                  setDescription(e.target.value);
                                }}
                                value={description}
                              />
                            </Typography>
                          </ListItem>
                        </>
                      )}
                      {usageType === USAGE_TYPE_COMBO && (
                        <ListItem className={classes.itemForm}>
                          <Typography
                            component="div"
                            className={classes.labelControl}
                          >
                            <AnyButton />
                          </Typography>
                          <Typography
                            component="div"
                            className={classes.divisionLabel}
                          >
                            利用制限
                          </Typography>
                          <RadioGroup
                            row
                            value={usageLimit}
                            onChange={e => {
                              setUsageLimit(parseInt(e.target.value, 10));
                            }}
                          >
                            <FormControlLabel
                              value={0}
                              control={<Radio color="primary" />}
                              label="なし"
                            />
                            <FormControlLabel
                              value={1}
                              control={<Radio color="primary" />}
                              label="1日1枚"
                            />
                          </RadioGroup>
                        </ListItem>
                      )}
                      <ListItem className={classes.itemForm}>
                        <Typography
                          component="div"
                          className={classes.labelControl}
                        >
                          <div className={classes.displayFlex}>
                            <div className={classes.divHelp}>
                              <AnyButton />
                            </div>
                            <HelpIcon
                              className={classes.iconHelpEx}
                              onClick={handleShowHelpExpiration}
                            />
                            {helpExpiration && (
                              <div ref={ref} className={classes.divExplanation}>
                                <Card>
                                  <CloseIcon
                                    className={classes.helpCloseBtn}
                                    onClick={handleCloseHelpPopup}
                                  />
                                  <CardContent
                                    className={classes.textHelpExplainDiv}
                                  >
                                    <Typography
                                      className={classes.textHelpExplain}
                                    >
                                      【指定しない】
                                      <br />
                                      購入日から180日間ご利用いただけます。
                                      <br />
                                      <br />
                                      【期限指定】
                                      <br />
                                      利用できる期限日を日付で指定して設定できます。
                                      <br />
                                      例）〜3月31日まで→購入日に関わらず3月31日まで利用可能
                                      <br />
                                      <br />
                                      【期間指定】
                                      <br />
                                      チケットを購入してから利用できる期間を日数で指定して設定できます。
                                      <br />
                                      例）30日間利用可能→購入日が1月1日の場合、1月31日まで利用可能
                                      <br />
                                      ※チケットの利用期間は最長で購入日から180日間です。
                                    </Typography>
                                  </CardContent>
                                </Card>
                              </div>
                            )}
                          </div>
                        </Typography>
                        <Typography
                          component="div"
                          className={classes.divisionLabel}
                        >
                          利用期間
                        </Typography>
                        <RadioGroup
                          col="true"
                          value={expirationType}
                          onChange={e => {
                            setExpirationType(parseInt(e.target.value, 10));
                            resetExpirationValue();
                          }}
                        >
                          <FormControlLabel
                            value={2}
                            control={<Radio color="primary" />}
                            label="指定しない"
                          />
                          <FormControlLabel
                            value={1}
                            control={<Radio color="primary" />}
                            label="期限指定"
                          />
                          <FormControlLabel
                            value={0}
                            control={<Radio color="primary" />}
                            label="期間指定"
                          />
                        </RadioGroup>
                        {expirationType === 0 && (
                          <Typography
                            component="div"
                            className={classes.formInput}
                          >
                            <TextField
                              select
                              label="利用期間"
                              className={classes.textFieldLong}
                              margin="normal"
                              InputLabelProps={{
                                shrink: true
                              }}
                              value={expiration}
                              onChange={e => {
                                setExpiration(e.target.value);
                              }}
                              // onBlur={validExpiration}
                            >
                              {expirationList.map(item => {
                                return (
                                  <MenuItem key={item.value} value={item.value}>
                                    {item.label}
                                  </MenuItem>
                                );
                              })}
                            </TextField>
                            <ValidationText message={errors.expirationError} />
                          </Typography>
                        )}
                        {expirationType === 1 && (
                          <Typography
                            component="div"
                            className={classes.formInput}
                          >
                            <TextField
                              label="終了"
                              type="date"
                              className={classes.textFieldLong}
                              margin="normal"
                              InputLabelProps={{
                                shrink: true
                              }}
                              value={expirationEndDate}
                              inputProps={{
                                min: minExpirationDate,
                                max: maxExpirationDate
                              }}
                              onChange={e => {
                                setExpirationEndDate(e.target.value);
                              }}
                            />
                          </Typography>
                        )}
                      </ListItem>
                      {usageType === USAGE_TYPE_VOUCHER && (
                        <ListItem className={classes.itemForm}>
                          <Typography
                            component="div"
                            className={classes.labelControl}
                          >
                            <RequiredButton />
                          </Typography>
                          <Typography
                            component="div"
                            className={classes.formInput}
                          >
                            <Typography className={classes.divisionLabel}>
                              利用方法
                            </Typography>
                            <RadioGroup
                              value={menuLimitTotal}
                              onChange={e => {
                                setMenuLimitTotal(parseInt(e.target.value, 10));
                              }}
                            >
                              <FormControlLabel
                                value={1}
                                control={<Radio color="primary" />}
                                label="一円単位利用"
                              />
                              <div
                                className={classes.noteLimitTotal}
                                style={{ marginBottom: 16 }}
                              >
                                残高が無くなるまで、一円単位で任意の金額を指定してご利用いただけます。
                              </div>
                              <FormControlLabel
                                value={0}
                                control={<Radio color="primary" />}
                                label="一枚単位利用"
                              />
                              <div className={classes.noteLimitTotal}>
                                額面が決まっているチケットを一枚ずつご利用いただけます。お釣りは出ません。
                              </div>
                            </RadioGroup>
                          </Typography>
                        </ListItem>
                      )}
                      {usageType !== USAGE_TYPE_COMBO && (
                        <ListItem className={classes.itemForm}>
                          <Typography
                            component="div"
                            className={classes.labelControl}
                          >
                            <div className={classes.displayFlex}>
                              <div className={classes.divHelp}>
                                <AnyButton />
                              </div>
                              <HelpIcon
                                className={classes.iconHelpEx}
                                onClick={handleShowHelpDonation}
                              />
                              {helpDonation && (
                                <div
                                  ref={ref}
                                  className={classes.divExplanation}
                                >
                                  <Card>
                                    <CloseIcon
                                      className={classes.helpCloseBtn}
                                      onClick={handleCloseHelpPopup}
                                    />
                                    <CardContent
                                      className={classes.textHelpExplainDiv}
                                    >
                                      <Typography
                                        className={classes.textHelpExplain}
                                        style={{ margin: '20px 0 0' }}
                                      >
                                        設定すると自動的に「誰でもごち」になり、税率が0％になります。
                                        <br />
                                        誰でもごちとは？
                                        <br />
                                        自分用やギフト用に購入するのではなく、「お店に寄付」してお店を訪れた不特定の相手にご利用いただく「ごち（チケット）」です。
                                        <br />
                                        詳細はマニュアルをご確認ください。
                                        <br />
                                        {`マニュアル： `}
                                        <Link
                                          href="https://shop-guide.gochimeshi.com/individual/daredemogochi-operation-manual/"
                                          target="_blank"
                                          color="primary"
                                        >
                                          https://shop-guide.gochimeshi.com/individual/daredemogochi-operation-manual/
                                        </Link>
                                        <br />
                                        ※チケットのご利用には、ユーザー登録が必要です。
                                        <br />
                                        ※店頭に専用QRコードをご用意いただき、ユーザー様のスマートフォンで読み取っていただく事でチケットを呼び出せます。
                                      </Typography>
                                    </CardContent>
                                  </Card>
                                </div>
                              )}
                            </div>
                          </Typography>
                          <Typography
                            component="div"
                            className={classes.formInput}
                          >
                            <FormControlLabel
                              control={
                                <Checkbox id="isDonation" color="primary" />
                              }
                              label="寄付設定"
                              checked={taxType === 'DONATION'}
                              onChange={e => {
                                if (e.target.checked) {
                                  setTaxType('DONATION');
                                } else {
                                  setTaxType('INTERNAL');
                                }
                                calcPrice(e);
                              }}
                              disabled={shopGochiRestriction === 'MENTION_ONLY'}
                            />
                          </Typography>
                        </ListItem>
                      )}
                      <ListItem className={classes.qaBox}>
                        <Typography
                          component="div"
                          style={{ width: '100%' }}
                          className={classes.labelControl}
                        >
                          <div
                            className={classes.displayFlex}
                            style={{ alignItems: 'flex-start' }}
                          >
                            <div className={classes.divHelp}>
                              <span className={classes.headerNoteDonation}>
                                Q.
                              </span>
                              <span className={classes.questionTextDonation}>
                                金額を非表示にするには？
                              </span>
                            </div>
                            {showQADonation ? (
                              <RemoveCircleOutline
                                color="primary"
                                onClick={() => setShowQADonation(false)}
                                style={{ cursor: 'pointer' }}
                              />
                            ) : (
                              <AddCircleOutline
                                color="primary"
                                onClick={() => setShowQADonation(true)}
                                style={{ cursor: 'pointer' }}
                              />
                            )}
                          </div>
                          {showQADonation && (
                            <div className={classes.answerNoteDonation}>
                              <div className={classes.headerNoteDonation}>
                                A.
                              </div>
                              <div className={classes.answerTextDonation}>
                                <div>
                                  ギフト券の場合、金額を非表示にすることが可能です。
                                  <br />
                                  ご要望がある場合はお問い合わせください。
                                </div>
                                <div style={{ marginTop: 8 }}>
                                  お問い合わせフォーム
                                </div>
                                <div>
                                  <Link
                                    href="https://support.gigi.tokyo/contact/contact01/"
                                    target="_blank"
                                    color="primary"
                                  >
                                    https://support.gigi.tokyo/contact/contact01/
                                  </Link>
                                </div>
                              </div>
                            </div>
                          )}
                        </Typography>
                      </ListItem>
                    </>
                  )}
                </>
              )}
            </List>
          </Paper>
          <div className={classes.btnBtom}>
            <CancelButton onClickAction={cancelAction} color="primary" />
            <ConfirmButton onClickAction={confirmAction} />
          </div>
        </div>

        <Modal open={openMenuImageSamplePopup} className={classes.modalMobile}>
          <MenuImageSampleShopDialog
            handleClose={() => updateOpenMenuImageSamplePopup(false)}
            menuImageSampleList={menuImageSampleList}
            setPreviewImage={setPreviewImage}
            setIsImageDefault={setIsImageDefault}
            setImageError={setImageError}
          />
        </Modal>

        <Modal open={openAddConfirm} className={classes.modalMobile}>
          <GochiMenuAddConfirmShopV2
            backAction={() => updateOpenAddConfirm(false)}
            registerAction={registerAction}
            addConfirm={multiLangData}
            reducedTaxMenuPrefix={reducedTaxMenuPrefix}
            shopName={shopName}
            currentLanguage={isLanguage}
            menuGenreName={menuGenreName}
            getUsageTypeName={getUsageTypeName}
          />
        </Modal>
      </>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
